import { FC } from "react";

import { NotificationItemFooterDefinitionStyled } from "./notification-item-footer-definition.styled";

export interface INotificationItemFooterDefinitionProps {
  title: string;
  description: string;
}

export const NotificationItemFooterDefinition: FC<
  INotificationItemFooterDefinitionProps
> = ({ description, title }) => {
  return (
    <NotificationItemFooterDefinitionStyled>
      <strong>{title}: </strong>
      {description}
    </NotificationItemFooterDefinitionStyled>
  );
};
